import { ReportPage } from './ReportPage';

export function ProjectStaffing() {
  return <ReportPage reportName="Project staffing" />;
}
